import { render } from "./CourseDetailsDisplay.vue?vue&type=template&id=9280191e"
import script from "./CourseDetailsDisplay.vue?vue&type=script&lang=js"
export * from "./CourseDetailsDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__